import { useQuery } from "@tanstack/react-query";
import { listDelegationInvitations } from "../../api/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useDelegationInvitations = (enabled = true) =>
  useQuery({
    queryKey: delegationQueryKeys.invitations,
    queryFn: listDelegationInvitations,
    enabled,
  });
